@if (label) {
  <label class="form-label">{{ label }}</label>
}

<div class="inline-block relative mb-1.5 w-full">
  @if (hasSelectedItem === false && !optional()) {
    <Button
        color="red"
        size="xsmall"
        class="w-full"
        [disabled]="disabled()"
        [class]="'flex-row justify-between text-left'"
        [outline]="true"
        (click)="toggleItems()">
      <div [class.opacity-75]="disabled()">
        <div class="text-left text-[13px] font-normal">{{ inlineHeader() }}</div>
        <div class="mr-2 text-[17px] text-left"
             [innerHTML]="translationPrefix ? (translationPrefix + selectedItemDisplayName | translate) : selectedItemDisplayName"></div>
      </div>
      <!-- chevron -->
      @if (!disabled()) {
        <svg [class.rotate-180]="expanded()" class="fill-current h-5 w-5 sm:mt-0" xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 20 20">
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
        </svg>
      }
    </Button>
  }
  @if (hasSelectedItem === true) {
    <Button
        color="dropdown"
        size="xsmall"
        class="w-full"
        [disabled]="disabled()"
        [class]="'flex-row justify-between text-left'"
        [outline]="false"
        (click)="toggleItems()">
      <div [class.opacity-75]="disabled()" [class.text-gray-600]="expanded()">
        <div class="text-left text-[13px] dark:bg-dropdown-inline-header-dark" [style.color]="expanded() ? appColor() : ''">{{ inlineHeader() }}</div>
        <div class="mr-2 text-[17px] text-left" [class.py-2]="!inlineHeader()" [class.dark:bg-dropdown-inline-header-dark]="expanded()" [innerHTML]="translationPrefix ? (translationPrefix + selectedItemDisplayName | translate) : selectedItemDisplayName"></div>
        @if (description) {
          <div class="font-normal font-sans px-3 mt-2 mb-1 py-1 text-xxs text-left bg-yellow-50 border border-yellow-100 rounded-full w-full" [innerHTML]="description"></div>
        }
      </div>
      <!-- chevron -->
      @if (!disabled()) {
        <svg [class.rotate-180]="expanded()" class="fill-current h-5 w-5 sm:mt-0" xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 20 20">
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
        </svg>
      }
    </Button>
  }
  @if (hasSelectedItem === undefined || (hasSelectedItem === false && optional())) {
    <Button
        color="dropdown"
        size="xsmall"
        class="w-full"
        [disabled]="disabled()"
        [class]="'flex-row justify-between text-left'"
        [outline]="false"
        (click)="toggleItems()">
      <div [class.opacity-75]="disabled()" [class.text-gray-600]="expanded()">
        <div class="text-left text-[13px] font-normal dark:bg-dropdown-inline-header-dark"
             [style.color]="expanded() ? appColor() : ''">{{ inlineHeader() }}
        </div>
        <div class="mr-2 text-[17px] text-left"
             [class.dark:bg-dropdown-inline-header-dark]="expanded()">{{ translationPrefix && selectedItemDisplayName ? (translationPrefix + selectedItemDisplayName | translate) : (selectedItemDisplayName ? selectedItemDisplayName : (inlineLabel ? inlineLabel : makeChoiceLabel())) }}
        </div>
      </div>
      <!-- chevron -->
      @if (!disabled()) {
        <svg [class.rotate-180]="expanded()" class="fill-current h-5 w-5 sm:mt-0" xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 20 20">
          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
        </svg>
      }
    </Button>
  }

  <ul [class.hidden]="!expanded()"
      class="absolute w-full bg-dropdown dark:bg-dropdown-dark shadow-dropdown text-gray-800 dark:text-white font-medium z-40 overflow-y-auto overscroll-none shadow -mt-1 pt-2 rounded">
    @if (optional()) {
      <li (click)="selectItem(deselectOption); expanded.set(false)" class="ml-0 leading-5 rounded-t z-40 py-2.5 px-3 block cursor-pointer hover:text-gray-600">{{ makeChoiceLabel() }}</li>
    }
    @for (item of items(); track item.id ? item.id : (item.value ? item.value : (item.displayName ? item.displayName : item)); let first = $first; let last = $last) {
      <li (click)="selectItem(item); expanded.set(false)" [class.rounded-t]="first && !optional()" [class.rounded-b]="last"
          class="ml-0 leading-5 z-40 py-2.5 px-3 flex flex-row cursor-pointer">
        <span class="flex-grow hover:text-gray-500"
              [innerHTML]="translationPrefix ? ((translationPrefix + (item.displayName ? item.displayName : (item.value ? item.value : item))) | translate) : (item.displayName ? item.displayName : (item.value ? item.value : item))"></span>
        @if (item.advisePercentage) {
          <span class="text-xxs text-gray-300">{{ ('INCLUDE_STEP_LABEL_DROPDOWN_ADVICE' | translate: {percentage: item.advisePercentage}) }}</span>
        }
      </li>
    }
  </ul>
</div>
